import { AppState } from "../rootReducer";

export const getExternalProfileUser = (state: AppState) =>
  state.externalProfile;

export const getExternalProfilePicture = (state: AppState) =>
  state.externalProfile.picture || "";

export const getExternalProfileFirstName = (state: AppState) =>
  state.externalProfile.firstName || "";

export const getExternalProfileLastName = (state: AppState) =>
  state.externalProfile.lastName || "";

export const getExternalProfileRequesting = (state: AppState) =>
  state.externalProfile.requesting || false;

export const getExternalProfileNotificationRequesting = (state: AppState) =>
  state.externalProfile.notificationRequesting || false;

export const getExternalProfileCategories = (state: AppState) =>
  state.externalProfile.categories;

export const getExternalProfileSkills = (state: AppState) =>
  state.externalProfile.skills || [];

export const getExternalProfileAchievements = (state: AppState) =>
  state.externalProfile.achievements || [];

export const getExternalProfileBio = (state: AppState) =>
  state.externalProfile.bio || "";

export const getExternalProfilembti = (state: AppState) =>
  state.externalProfile.mbti || "";

export const getExternalProfileJobDescription = (state: AppState) =>
  state.externalProfile.jobDescription || "";

export const getExternalProfileBestStreak = (state: AppState) =>
  state.externalProfile.bestStreak || 0;

export const getExternalProfilePulseSent = (state: AppState) =>
  state.externalProfile.pulseSent || 0;

export const getExternalProfileTotalDoneActions = (state: AppState) =>
  state.externalProfile.totalDoneActions || 0;

export const getExternalProfileId = (state: AppState) =>
  state.externalProfile._id || "";
